import { render, staticRenderFns } from "./HomeCompeticoesFiltro.vue?vue&type=template&id=547bca68&"
import script from "./HomeCompeticoesFiltro.vue?vue&type=script&lang=js&"
export * from "./HomeCompeticoesFiltro.vue?vue&type=script&lang=js&"
import style0 from "./HomeCompeticoesFiltro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports